import { IntlShape } from 'react-intl';

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const MONTH_MS = 30 * DAY_MS;
const YEAR_MS = 365 * DAY_MS;

/**
 * "3 minutes ago" / "2 hours ago" / "3 days ago" / "5 months ago" / "2 years ago" in the active
 * locale, clamped to one minute so a just-touched timestamp never reads "in 0 seconds".
 *
 * Rounds down, so the figure never overstates the gap — the resume banner would otherwise be able
 * to say "5 minutes ago" about a conversation that qualified as under five minutes idle. The two
 * coarse units are a flat thirty days and 365, which is all the precision a record last touched
 * that long ago is being read for.
 */
export const formatRelativeTimeFromNow = (intl: IntlShape, timestampMs: number): string => {
    const elapsed = Math.max(0, Date.now() - timestampMs);

    if (elapsed < HOUR_MS) {
        return intl.formatRelativeTime(-Math.max(1, Math.floor(elapsed / MINUTE_MS)), 'minute');
    }
    if (elapsed < DAY_MS) {
        return intl.formatRelativeTime(-Math.floor(elapsed / HOUR_MS), 'hour');
    }
    if (elapsed < MONTH_MS) {
        return intl.formatRelativeTime(-Math.floor(elapsed / DAY_MS), 'day');
    }
    if (elapsed < YEAR_MS) {
        return intl.formatRelativeTime(-Math.floor(elapsed / MONTH_MS), 'month');
    }
    return intl.formatRelativeTime(-Math.floor(elapsed / YEAR_MS), 'year');
};
